var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { RediError, } from '@wendellhu/redi';
import * as React from 'react';
import { RediContext } from './reactContext';
var HooksNotInRediContextError = /** @class */ (function (_super) {
    __extends(HooksNotInRediContextError, _super);
    function HooksNotInRediContextError() {
        return _super.call(this, 'Using dependency injection outside of a RediContext.') || this;
    }
    return HooksNotInRediContextError;
}(RediError));
export function useInjector() {
    var injectionContext = React.useContext(RediContext);
    if (!injectionContext.injector) {
        throw new HooksNotInRediContextError();
    }
    return injectionContext.injector;
}
export function useDependency(id, quantityOrLookUp, lookUp) {
    var injector = useInjector();
    return React.useMemo(function () { return injector.get(id, quantityOrLookUp, lookUp); }, [id, quantityOrLookUp, lookUp]);
}
//# sourceMappingURL=reactHooks.js.map